import React from 'react';
import { ClockIcon, ShieldCheckIcon, TrendingUpIcon, WalletIcon } from 'lucide-react';
import { benefits } from '../data/content';
const icons = {
  clock: ClockIcon,
  shield: ShieldCheckIcon,
  chart: TrendingUpIcon,
  wallet: WalletIcon
};
export function Benefits() {
  return <section className="px-5 py-8" aria-labelledby="beneficios-title" data-id="element-31" data-mp="3vr0aby3mfvrw">
      <h2 id="beneficios-title" className="font-display text-[22px] leading-snug text-[#16302a]" data-id="element-32" data-mp="3vomhlvweyvni">
        Lo que cambia en tus clases desde la primera semana
      </h2>

      <ul className="mt-5 space-y-3" data-id="element-33" data-mp="3mp98x5g46b3u">
        {benefits.map(b => {
        const Icon = icons[b.icon as keyof typeof icons];
        return <li key={b.title} className="flex gap-3 rounded-2xl border border-[#c9d6cd] bg-[#3f5d4e] p-4 text-[#f6f3ec]" data-id="element-34" data-mp="3cs4i2sbbprgp">
              <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#f6f3ec]/15" data-id="element-35" data-mp="1fyt8bmk239ch">
                <Icon className="h-5 w-5 text-[#dfe9e0]" aria-hidden="true" data-id="element-36" data-mp="1ayote0ysqmod" />
              </span>
              <div data-id="element-37" data-mp="2tkckqafq608">
                <p className="text-[14px] font-bold" data-id="element-38" data-mp="6sjioe7wk8t9">{b.title}</p>
                <p className="mt-1 text-[13.5px] leading-relaxed text-[#dbe5dc]" data-id="element-39" data-mp="6qov0s58y2lh">{b.text}</p>
              </div>
            </li>;
      })}
      </ul>
    </section>;
}